import { useEffect } from "react";
import { useMatches } from "react-router";

export const usePageTitleUpdater = () => {
    const pageTitle = usePageTitle();

    useEffect(() => {
        document.title = pageTitle ? `ShareGate | ${pageTitle}` : "ShareGate";
    }, [pageTitle]);

    return null;
};

function useRouteHandle(name: string): string | null {
    const matches = useMatches();

    // Search from the deepest route up to find the first handle with the requested property
    for (let i = matches.length - 1; i >= 0; i--) {
        const route = matches[i];

        if (!route?.handle) {
            continue;
        }

        const value = (route.handle as Record<string, unknown>)[name];

        if (typeof value === "string") {
            return value;
        }
    }

    return null;
}

export function usePageTitle(): string | null {
    return useRouteHandle("pageTitle");
}
